import { Input } from "antd";

function SearchBar({ onChange, style }) {
  return (
    <div
      style={{
        width: "350px",
        outline: "none",
        border: "none",
        padding: "4px 8px",
        borderRadius: "4px",
      }}
    >
      <Input
        size="default size"
        placeholder="Search"
        onChange={onChange}
      />
    </div>
  );
}

export default SearchBar;
